import styled from 'styled-components';
import MuiDialog from '@mui/material/Dialog';
import MuiDialogContent from '@mui/material/DialogContent';
import MuiDialogTitle from '@mui/material/DialogTitle';
import Box from '@mui/material/Box';
import MuiDialogContentText from '@mui/material/DialogContentText';

const Dialog = styled(MuiDialog)`
	width: 100%;
	overflow: auto;
	& .MuiDialog-paper {
		padding: 30px;
	}
`;

const DialogTitle = styled(MuiDialogTitle)`
	display: flex;
	justify-content: start;
	align-items: center;
	gap: 15px;
	padding-left: 0;
	padding-right: 0;
`;

const DialogContent = styled(MuiDialogContent)`
	display: flex;
	flex-direction: column;
	align-items: stretch;
	text-align: start;
	overflow-y: auto;
	max-height: 80vh;
`;

const Head = styled(Box)`
	width: 100%;
	display: flex;
	justify-content: flex-start; /* Align content to the start */
	align-items: flex-start; /* Align items to the top */
	flex-direction: column;
`;

const DialogContentText = styled(MuiDialogContentText)`
	font-weight: 500;
	text-align: start;
`;

export default {
	Head,
	Dialog,
	DialogTitle,
	DialogContent,
	DialogContentText
};
